export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6573.9f8bdf70.jpg";